export enum ElementId {
  MedialRedactorInfo = "medical-redactor-info"
}
